export default __webpack_public_path__ + "static/media/054-money-1.af94e937.svg";